import React from 'react';
export function SecondSlide() {
  return <div className="w-full min-h-screen bg-[#f9f9f9]" data-id="element-57">
      {/* Mobile Layout */}
      <div className="md:hidden flex flex-col" data-id="element-58">
        {/* Image first on mobile */}
        <div className="w-full" data-id="element-59">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pAdszdo5LBwCPfmUQKzBWS/Madeleine-Morlet-4.jpg" alt="Mother holding child" className="w-full h-auto object-contain" data-id="element-60" />
        </div>

        {/* Text content below image */}
        <div className="px-6 py-12" data-id="element-61">
          {/* Headline */}
          <h2 style={{
          fontFamily: 'Arial, Helvetica, sans-serif',
          fontSize: '24px',
          fontWeight: '700',
          lineHeight: '1.1',
          marginBottom: '24px'
        }} data-id="element-62">
            the time is right for a publication like the 4th.
          </h2>

          {/* Body text */}
          <div style={{
          fontFamily: 'Georgia, serif',
          fontSize: '11px',
          lineHeight: '1.6',
          color: '#000'
        }} data-id="element-63">
            <p style={{
            marginBottom: '16px'
          }} data-id="element-64">
              An annual arts and culture magazine based in the UK, it embraces
              the interplay between womanhood, identity, and contemporary
              motherhood through highly curated content.
            </p>

            <p style={{
            marginBottom: '16px'
          }} data-id="element-65">
              There not only is a desire to see mothers portrayed in a new
              light, there is a cultural and social need. Across the world,
              women from diverse fields are actively challenging outdated
              notions of motherhood; yet their voices, however brilliant, often
              remain scattered and hard to find.
            </p>

            <p data-id="element-66">
              <em data-id="element-67">the 4th</em> brings these voices together.
            </p>
          </div>
        </div>
      </div>

      {/* Desktop Layout */}
      <div className="hidden md:flex min-h-screen" data-id="element-68">
        {/* Left side - Text content */}
        <div className="flex-1 flex items-center justify-center px-12 lg:px-20" data-id="element-69">
          <div data-id="element-70">
            {/* Headline */}
            <h2 style={{
            fontFamily: 'Arial, Helvetica, sans-serif',
            fontSize: '32px',
            fontWeight: '700',
            lineHeight: '1.1',
            marginBottom: '32px',
            maxWidth: '420px'
          }} data-id="element-71">
              the time is right for a publication like the 4th.
            </h2>

            {/* Body text - with exact line breaks */}
            <div style={{
            fontFamily: 'Georgia, serif',
            fontSize: '11px',
            lineHeight: '1.6',
            color: '#000',
            maxWidth: '420px'
          }} data-id="element-72">
              <p style={{
              marginBottom: '16px'
            }} data-id="element-73">
                An annual arts and culture magazine based in the UK,
                <br data-id="element-74" />
                it embraces the interplay between womanhood, identity,
                <br data-id="element-75" />
                and contemporary motherhood through highly curated
                <br data-id="element-76" />
                content.
              </p>

              <p style={{
              marginBottom: '16px'
            }} data-id="element-77">
                There not only is a desire to see mothers portrayed in a new
                <br data-id="element-78" />
                light, there is a cultural and social need. Across the world,
                <br data-id="element-79" />
                women from diverse fields are actively challenging outdated
                <br data-id="element-80" />
                notions of motherhood; yet their voices, however brilliant,
                <br data-id="element-81" />
                often remain scattered and hard to find.
              </p>

              <p data-id="element-82">
                <em data-id="element-83">the 4th</em> brings these voices together.
              </p>
            </div>
          </div>
        </div>

        {/* Right side - Image */}
        <div className="flex-shrink-0" data-id="element-84">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pAdszdo5LBwCPfmUQKzBWS/Madeleine-Morlet-4.jpg" alt="Mother holding child" className="h-screen w-auto object-cover" data-id="element-85" />
        </div>
      </div>
    </div>;
}